import { createFileRoute } from '@tanstack/react-router'
import About from 'pages/learn/[blog-slug]'
import { getBlogPost } from 'content/blog-posts'
import { articleSchema, canonicalLink, ldJsonScript, pageMeta, SITE_URL } from 'lib/seo'

// The posts are a static list, so the title is known from the slug alone — no
// loader needed, on the server or in the browser.
export const Route = createFileRoute('/learn/$blogSlug')({
   head: ({ params }) => {
      const post = getBlogPost(params.blogSlug)
      if (!post) return { meta: [{ title: 'Article not found' }] }
      const url = `${SITE_URL}/learn/${params.blogSlug}`
      return {
         meta: pageMeta({
            title: post.title,
            description: post.metaDescription,
            url,
            ogType: 'article',
         }),
         links: [canonicalLink(url)],
         scripts: [
            ldJsonScript(
               articleSchema({ url, headline: post.title, description: post.metaDescription })
            ),
         ],
      }
   },
   component: About,
})
